import httpClient from 'src/common/fetch'
import { CreateOrderDTO, UpdateBurnDTO } from './dto'
import { OrderModel, OrdersModel, GraphModel, FxRateObservation } from './models'

export const createMintOrder = (params: CreateOrderDTO) => httpClient.post<OrderModel>('/orders/mint', params)

export const createBurnOrder = (params: CreateOrderDTO) => httpClient.post<OrderModel>('/orders/burn', params)

export const updateBurnOrder = (params: UpdateBurnDTO) => httpClient.put('/orders/burn', params)

interface FilterParams {
  type?: string
  status?: string
  chain?: string
  asset?: string
  fiatCurrency?: string
  sortBy?: string
  page?: number
}

export const getOrders = (params?: FilterParams, signal?: AbortSignal) =>
  httpClient.get<OrdersModel>('/orders', { params, signal })

export const getGraphOrders = () => httpClient.get<GraphModel>('/orders/analytics')

export const getFxRateObs = () =>
  fetch('https://www.bankofcanada.ca/valet/observations/FXUSDCAD/json').then((res) => res.json()) as Promise<{
    observations: FxRateObservation[]
  }>

export const getOrder = (orderId: string) =>
  httpClient.get<OrdersModel>('/orders', {
    params: {
      orderId: orderId
    }
  })

export const cancelOrder = (orderId: string, orgId: string) =>
  httpClient.put('/orders/cancel', {
    orderId,
    orgId
  })

export const getReturnAddress = (chain: string, asset: string) =>
  httpClient.get<{ address: string }>('/orders/return-address', {
    params: { chain, asset }
  })
